/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import {EMPTY_VALUES} from "../../../../../../../../Apis/functions";

/**
 * Value of the folio read below the label that names it.
 *
 * A value nobody registered is read with the label the section declares for it,
 * so the ones the gate still has to write say that they are waited for instead
 * of reading as a value the folio does not carry.
 */
const LabeledTextSection = ({t, title, value, emptyText = EMPTY_VALUES.DEFAULT}) => {
    return (
        <>
            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0'>
                {t(title)}
            </p>
            <p className='font-color-general-950 fs-14px px-0'>
                {value || emptyText}
            </p>
        </>
    );
};

export default LabeledTextSection;
